// src/theme/foundations/typography.js
export const typography = {
    fonts: {
      heading: '"KoHo", sans-serif',
      body: '"KoHo", sans-serif',
    }
  };